import { useContext } from "react";

import HistorialClinicoContext from "../context/HistorialClinicoProvider";

const useHistorialClinico = () => {
    return useContext(HistorialClinicoContext)
}

export default useHistorialClinico